import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';

interface Props {
  className?: string;
  loading?: boolean;
  onClear: () => void;
}

export default function TableMultiselectFilterActions(props: Props) {
  const { className, loading, onClear } = props;
  const { t } = useTranslation();
  return (
    <ActionsRow
      className={className}
      actions={[
        <Button
          key="secondary"
          buttonType={ButtonTypes.secondaryOutlined}
          buttonText={t('clear-filter')}
          leftIcon="close"
          onClick={onClear}
          fullWidth
          disabled={loading}
        />,
        <Button
          key="primary"
          type="submit"
          buttonType={ButtonTypes.primaryFilled}
          buttonText={t('apply')}
          leftIcon="check"
          fullWidth
          disabled={loading}
        />,
      ]}
    />
  );
}
